import Typography from "typography";

const typography = new Typography({
  baseFontSize: "18px",
  scaleRatio: 2,
  baseLineHeight: 1.8,
  googleFonts: [
    {
      name: "Roboto",
      styles: ["Light", "Regular", "Bold"],
    },
    {
      name: "Open Sans",
      styles: ["Regular"],
    },
    {
      name: "Lato",
      styles: ["Light", "Regular", "Bold"],
    },
  ],
  headerFontFamily: ["Lato", "Arial"],
  headerWeight: "700",
  headerColor: "#282a36",
  bodyFontFamily: ["Roboto", "Open Sans", "Lato"],
  bodyWeight: "Regular",
  bodyColor: "#282a36",
});

// Hot reload typography in development.
if (process.env.NODE_ENV !== `production`) {
  typography.injectStyles();
}

export default typography;
export const scale = typography.scale;
